import type {ReactElement} from 'react';
import React from 'react';
import type {TextListObject} from '@PosterWhiteboard/items/text-item/text-list';
import {PosterEditingBaseColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-base-color-panel';
import type {RGBA} from '@Utils/color.util';
import {getRGBAArrayFromColorStorage} from '@Utils/color.util';
import {getColorFillTypeFromFillType, getColorObjectArrayFromFillColor} from '@Utils/color.util';
import type {ColorStorage} from '@Components/color-picker-v2';
import type {ColorFillPropertyType} from '@Components/color-fill';

interface BaseListColorPanelProps {
  list: TextListObject;
  updateFillColor(color: RGBA[], undoable?: boolean): void;
  onChangeType(newType: ColorFillPropertyType): void;
}

export function BaseListColorPanel({...props}: BaseListColorPanelProps): ReactElement {
  const getColorObject = (): ColorStorage[] => {
    return getColorObjectArrayFromFillColor(props.list.fill.fillColor);
  };

  const onChangeColor = (updatedColor: ColorStorage[]): void => {
    props.updateFillColor(getRGBAArrayFromColorStorage(updatedColor), false);
  };

  const onChangeColorEnded = (updatedColor: ColorStorage[]): void => {
    props.updateFillColor(getRGBAArrayFromColorStorage(updatedColor), true);
  };

  const onChangeType = (newType: ColorFillPropertyType): void => {
    props.onChangeType(newType);
  };

  return (
    <PosterEditingBaseColorPanel
      id="base-list-color-panel"
      type={getColorFillTypeFromFillType(props.list.fill.fillType)}
      onChangeType={onChangeType}
      color={getColorObject()}
      onChangeColor={onChangeColor}
      onChangeEnded={onChangeColorEnded}
    />
  );
}
